<template>
	<div class="h-list" style="width: 800px;margin: 20px auto">
		<div class="h-list-item">
			<div class="h-list-item-meta" v-for="(check,name) in checkList" :key="name">
				<span class="h-list-item-title font-bold">{{name}}：</span>
				<i v-if="check.loading" class="h-icon-loading"></i>
				<span v-if="check.msg" class="red-color">{{check.msg}}</span>
				<span v-else>{{check.loading ? '检查中...':'已完成'}}</span>
			</div>
		</div>
		<div class="text-center padding">
			<Button :loading="loading" @click="back">上一步</Button>
			<Button color="primary" :loading="loading" @click="invoicing" :disabled="!checked">结 账</Button>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
  /**
   * 检查界面
   */
	export default {
		name: "Check",
		props: {
			checkYear: [Number, String],
			checkMonth: [Number, String],
		},
		data() {
			return {
				loading: false,
				checkList: {
					"期初检查": {
						loading: false
					},
					"期末检查": {
						loading: false
					},
					"报表检查": {
						loading: false
					},
					"断号检查": {
						loading: true
					}
				}
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			checked() {
				return Object.values(this.checkList).every(value => !value.loading && !value.msg);
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				// this.$api.checkout.initialCheck({year: this.checkYear, month: this.checkMonth}).catch(() => {
				// 	this.$set(this.checkList.期初检查, 'msg', "期初不平衡");
				// }).finally(() => {
				// 	this.$set(this.checkList.期初检查, 'loading', false);
				// });

				this.$api.checkout.finalCheck({year: this.checkYear, month: this.checkMonth}).finally(() => {
					this.$set(this.checkList.期末检查, 'loading', false);
				}).catch(() => {
					this.$set(this.checkList.期末检查, 'msg', "期末不平衡");
				});

				// this.$api.checkout.reportCheck({year: this.checkYear, month: this.checkMonth}).then(({data}) => {
				// 	this.$set(this.checkList.报表检查, 'loading', false);
				// 	if (!data.result) {
				// 		let num = data.资产类 - data.负债类;
				// 		this.$set(this.checkList.报表检查, 'msg', `资产负债不平衡，(资产(${data.资产类}) - 负债(${data.负债类}) = ${num} != 权益(${data.权益类}))，差额 ${(num - data.权益类).toFixed(2)}`);
				// 	}
				// });

				this.$api.checkout.brokenCheck({year: this.checkYear, month: this.checkMonth}).finally(() => {
					this.$set(this.checkList.断号检查, 'loading', false);
				}).catch(() => {
					this.$set(this.checkList.断号检查, 'msg', "凭证号不连续");
				});
			},

      /**
       * 执行期末结账操作
       *
       * 调用后端 API 进行会计期间的期末结账处理，结账成功后执行以下操作：
       * 1. 显示成功提示信息
       * 2. 刷新 Vuex 状态数据
       * 3. 跳转到期末结转列表页面
       *
       * @returns {void} 无返回值，执行异步操作后更新 UI 状态和路由
       */
			invoicing() {
        // 设置页面加载状态为 true，显示加载动画并禁用按钮防止重复点击
				this.loading = true;
        // 调用后端 API 执行期末结账操作
        // 传递当前选中的结账年度和月份作为参数
				this.$api.checkout.invoicing({year: this.checkYear, month: this.checkMonth}).then(() => {
          // 结账成功后显示提示信息
					this.$Message("结转成功！");
          // 分发 Vuex action 刷新全局状态数据
          // 'init' action 会重新初始化应用的状态，确保数据是最新的
					// this.$store.dispatch('init');
          // // 跳转到期末结转列表页面
          // // name: "CheckList" - 路由名称，对应期末结转列表组件
					// this.$router.push({name: "CheckList"});
          // 等待 init 完成后再跳转，确保 checkoutList 已更新
          this.$store.dispatch('init').then(() => {
            // 跳转到期末结转列表页面
            // name: "CheckList" - 路由名称，对应期末结转列表组件
            this.$router.push({name: "CheckList"});
          });
				}).finally(() => {
          // 无论请求成功或失败，最终都恢复加载状态
          // 注意：这里设置为 true 可能是笔误，通常应该设置为 false
					this.loading = false;
				});
			},
			back() {
				this.$router.back();
			}
		}
	};
</script>

<style lang="less" scoped>
	.h-list-item-meta {
		margin: 20px;
	}
</style>
